jQuery(document).ready(function () {
    // Only Work If It Is A Checkout Page
  if(window.location.href.indexOf("/orders") > -1){
      	console.log('nothing to show');
        jQuery('.gift-coupan').hide();
    
  }else{
    if (window.location.href.indexOf("/checkouts") > -1) {
      jQuery('.total-line__name .reduction-code').css('background:yellow;font-weight:bold;padding:6px;');
      if(window.location.href.indexOf("/thank_you") > -1){
          console.log('nothing to show');
          jQuery('.gift-coupan').hide();
      }else{
        var step = $('#continue_button span:first').text();
          if(step == 'Pay now' ||step == 'Complete order'){
            console.log('here show');
			var captcha = "{{ 'shopify.online_store.spam_detection.disclaimer_html' | t }}";
          jQuery(".order-summary__section.order-summary__section--total-lines").before('<div class="gift-coupan" style="max-width: 500px; float: right; clear: both;"><div class="cardnumber-response" style="text-align: center;"></div><div class="cardnumber-response_success" style="text-align: right;"></div><form id="giftcoupan" style="margin-top: 10px;" action="" method="post"><input type="text" class="form-input cardnumber field__input" style="width: 76%; float: left; margin-bottom: 25px;" name="gift-coupon" placeholder="Enter Your Gift Card Number"><div id="html_element"></div><input style="padding: 12px 25px;margin-left: 11px;" class="button button--primary button--small btn" type="submit" value="Apply"></div><div id="re-captcha"></div></form><form id="apply-couponcode" action="/cart.php" method="post"><input class="gift-couponcode" id="couponcode" type="hidden" name="couponcode" value=""><input type="hidden" name="action" value="applycoupon"></form></div>');
          // Add styles
          jQuery("span.cart-gfc-label a").css('text-decoration', 'underline');
          jQuery("span.cart-gfc-label a").css('font-size', '12px');
          jQuery("#gfc-apply").css('padding', '6px 18px'); 
        }
      }
        
    }
  }
//   $("#checkout_reduction_code").attr('placeholder','Discount code');
//   console.log('here random'); 
  jQuery('#iamclick').on('click', function (e) {
	  //console.log('hello click');
	jQuery(".cardnumber-response").text("Processing, Please wait!");
	var cardnumber = jQuery(".cardnumber").val();
	var url = window.location.origin;
	e.preventDefault();
	// Get Current Cart Data
	jQuery.getJSON('/cart.js', function (cart) {
	    var app_url = 'https://oldeberlinvillage.localgiftcards.net/web/index.php/smarttransaction';
	    // get the order total
      var checkout_total = $("#data-subtotal-amount").text().replace('$','').replace(',', '');
      var checkout_total = checkout_total.match(/[0-9.]+/g);
     
      console.log("cdcd "+checkout_total);
	  // var checkout_total = parseFloat(checkout_total) + parseFloat(7.99);
      var checkout_total = parseFloat(checkout_total);
	    jQuery.ajax({
		type: 'post',
		dataType: "json",
		url: app_url + '/smarttransactionprocessing',
		crossDomain : true,
		data: {"cardnumber": cardnumber, "site_url": url, "cartAmount": checkout_total, "cart_id": cart.token},
		success: function (res) {
			if (res.status == 'success_insufficient') {
              jQuery.post('/cart/add.js', {
                  items: [
                    {
                      quantity: 1,
                      id: res.variant,
                    }
                  ]
                });
				jQuery(".cardnumber-response_success").text(res.info);
				jQuery(".cardnumber-response_success").addClass('insufficient');
				jQuery(".cardnumber-response_success").css('display','block');
				// jQuery('.offer_discount').val(res.code);
              	jQuery("input[name='discount']").val(res.code);
				//setTimeout(function () { jQuery('.checkout-buttons input').trigger('click'); }, 1000);
			//jQuery(".cardnumber-response").html('<span style="color:#33992c">Congrats, Gift card redeemed successfully!</span>');
              jQuery(".cardnumber-response").html('');

              jQuery('[data-trekkie-id="apply_discount_button"]').removeAttr("disabled");
              jQuery('button.field__input-btn.btn').removeClass("btn--disabled");
              jQuery("input#checkout_reduction_code").parent().parent().find('button').addClass('btngiftsubmit');  
              jQuery("input#checkout_reduction_code").val(res.code);
			}else if (res.status == 'success') {
              
              console.log('ENTERRRRRRRR: ', res.code);
				jQuery(".cardnumber-response_success").css('display','block');
				jQuery(".cardnumber-response_success").text(res.info);
				// jQuery('.offer_discount').val(res.code);
              	jQuery("input[name='discount']").val(res.code);
				
				//setTimeout(function () { jQuery('.checkout-buttons input').trigger('click'); }, 1000);
			//jQuery(".cardnumber-response").html('<span style="color:#33992c">Congrats, Gift card redeemed successfully!</span>');
              jQuery(".cardnumber-response").html('');

              jQuery('[data-trekkie-id="apply_discount_button"]').removeAttr("disabled");
              jQuery('button.field__input-btn.btn').removeClass("btn--disabled");
              jQuery("input#checkout_reduction_code").parent().parent().find('button').addClass('btngiftsubmit');  
              jQuery("input#checkout_reduction_code").val(res.code);
              
              
           
		    } else {
              jQuery(".cardnumber-response_success").css('display','none');
              if(res.mes == undefined){
              	jQuery(".cardnumber-response").html('<span style="color:red">Please try later.</span>');
              } else {
              	jQuery(".cardnumber-response").html('<span style="color:red">' + res.mes + '</span>');
              }
			
		    }
		},
		error: function (err) {
		    console.log('error: '+err);
          jQuery(".cardnumber-response_success").css('display','none');
          if(err.mes == undefined){
              	jQuery(".cardnumber-response").html('<span style="color:red">Please try later.</span>');
              } else {
              	jQuery(".cardnumber-response").html('<span style="color:red">' + err.mes + '</span>');
              }
		}
	    });
	});
    });

});

